import Login from "./login"
import Register from './register'
export default{
    Login,
    Register
}